import { Timeline } from "vue2vis";

export default {
	name: "TimelinePlayback",
	props: ["search", "srcImgToComponent", "urlVideoToComponent", "refVideoPlayToComponent"],
	components: { Timeline },
	
	data() {
		return {
			currentSegment: null,
			itemSelected: null,
			loading_timeline: false,
			items: [],
			timelineStart: (() => {
				const today = new Date();
				today.setHours(0, 0, 0, 0);
				return today;
			})(),
			timelineEnd: (() => {
				const today = new Date();
				today.setHours(23, 59, 59, 999);
				return today;
			})(),
			videoSearchDebounce: null,
			currentVideoSearch: null,
			options_timeline: {
				editable: false,
		        horizontalScroll: true,
		        verticalScroll: true,
		        stack: false,
				showMajorLabels: true,
				showMinorLabels: true,
				orientation: 'top',
				zoomMin: 1000,
				zoomMax: 1000 * 60 * 60 * 24,
				zoomKey: 'ctrlKey'
			},
			subgroupStack: { },
			group_promise: {
				cancel: false,
				promise: null,
				listens: {},
	 		}, 
			groups: [
	            { 
					id: 3, 
					content: '📹 Records', 
					order: 1,
					className: 'group-records'
				},
				{
					id: 4,
					content: '🧠 Smart Events',
					order: 2,
					className: 'group-smart-events',
					subgroupStack: { 
						sg_1: false, 
						sg_2: false, 
						sg_3: false, 
						sg_4: false, 
						sg_5: false, 
						sg_6: false, 
					},
				},
				{
					id: 5,
					content: '🚨 Alerts',
					order: 3,
					className: 'group-alerts',
					subgroupStack: { sg_1: false, sg_2: false, sg_3: false },
				},
				{ 
					id: 0, 
					content: '🚗 LPR', 
					order: 4,
					className: 'group-lpr'
				},
				{
					id: 2,
					content: '⚡ Actions',
					order: 5,
					className: 'group-actions',
					subgroupStack: { sg_1: false, sg_2: false, sg_3: false },
				},
				// Grupo Objects
				{
				 	id: 1,
				 	content: '🎯 Objects',	
				 	order: 6,
				 	subgroupStack: { 
						sg_1: false, 
						sg_2: false, 
						sg_3: false, 
						sg_4: false, 
						sg_5: false, 
						sg_6: false, 
						sg_7: false, 
						sg_8: false 
					},
				},
				{
					id: 6,
					content: '🛞 Axle',
					order: 7,
					className: 'group-axle'
				},
				{
					id: 7,
					content: '🔢 Counter',
					order: 8,
					className: 'group-counter'
				},
			],
			automaticRequestDebounce: null,
			analyticsRequestDebounce: null,
			lastAutomaticRequest: null,
			automaticRequestCooldown: 2000,
			scrollTimeout: null,
			isManualSearchInProgress: false,
			manualSearchCooldown: 3000,
			isManualTimelineMoveInProgress: false,
			timelineMoveCooldown: 2000,
			groupActive: false,
			// Optimización: Debouncing para range changes
			rangeChangeDebounce: null,
			rangeChangeThrottle: null,
			lastRangeChangeTime: 0,
			rangeChangeThrottleMs: 1500,
			// Optimización: RAF para actualizaciones del DOM
			rafPending: false,
			rafId: null,
			// Optimización: Batch de actualizaciones
			pendingTimelineUpdate: false,
			// Optimización: Throttling para syncParentDateControls
			syncDateControlsDebounce: null,
			lastSyncTime: 0,
			syncThrottleMs: 800
		};
	},

	created() {
		this.setDefault();
		this.groups[2].subgroupStack = {};
		

		
	},

	mounted() {
		this.$emit('timeline_dates_initialized', {
			startDate: this.formatDateToYYYYMMDD(this.timelineStart),
			endDate: this.formatDateToYYYYMMDD(this.timelineEnd),
			startTime: this.formatTimeForParent(this.timelineStart),
			endTime: this.formatTimeForParent(this.timelineEnd),
			explanation: 'Timeline dates initialized with actual timeline values'
		});
		
		this.$nextTick(() => {
			if (this.search && this.search.start && this.search.end) {
				this.getAnalytics({
					start: this.search.start,
					end: this.search.end,
					deviceId: this.search.deviceId,
					isManualSearch: true
				});
			}
			
			if (this.isTimelineReady()) {
				this.setupBidirectionalSync();
			}
		});
	},

	watch: {
		search: {
			handler: function(val, oldVal) {

				
				if (val && val.start && val.end) {
					
					
					// Activar flag de búsqueda manual para bloquear requests automáticos
					this.isManualSearchInProgress = true;
					
					// Resetear el cooldown de requests automáticos
					this.lastAutomaticRequest = Date.now();
					
					// Hacer el call correcto con el formato válido (NO el formato inválido anterior)
					this.getAnalytics({
						start: val.start,
						end: val.end,
						deviceId: val.deviceId,
						isManualSearch: true
					});
					
					// Desactivar el flag después del cooldown
					setTimeout(() => {
						this.isManualSearchInProgress = false;
					}, this.manualSearchCooldown);
				}
			},
			deep: true,
			immediate: false
		},
		
		// Watcher para debuggear los items
		items: {
			handler: function(newItems, oldItems) {
				// Items changed - logging removed for cleaner console
			},
			deep: true
		}
	},

	methods: {
		// Métodos básicos
		setDefault() {
			this.items = [];
		},


		clearListeners() {
			if (this.group_promise && this.group_promise.listens && this.$refs && this.$refs.timeline) {
				for (let it in this.group_promise.listens) {
					this.$refs.timeline.off(it, this.group_promise.listens[it]);
				}
			}
		},

		clearGroups() {
			this.group_promise.cancel = true;
			this.items = [];
			const timer = setTimeout(() => {
				this.group_promise.cancel = false;
				clearTimeout(timer);
			}, 50);
		},

		getAnalytics(params) {
			const isManual = this.isManualSearch(params);
			const isRangeChange = params?.requestReason === 'range_change';
			
			// Throttling adicional para requests automáticos
			if (!isManual && isRangeChange) {
				const now = Date.now();
				const timeSinceLastRequest = now - (this.lastAutomaticRequest || 0);
				if (timeSinceLastRequest < 1500) {
					// Cancelar request anterior si existe
					if (this.analyticsRequestDebounce) {
						clearTimeout(this.analyticsRequestDebounce);
					}
					// Programar request para después del throttle
					this.analyticsRequestDebounce = setTimeout(() => {
						this.getAnalytics(params);
					}, 1500 - timeSinceLastRequest);
					return;
				}
				this.lastAutomaticRequest = now;
			}
			
			if (isManual) {
				this.isManualSearchInProgress = true;
				this.lastAutomaticRequest = Date.now();
			}
			
			this.clearListeners();
			this.loading_timeline = true;

			let startDate, endDate;
			
			if (isRangeChange && this.isTimelineReady()) {
				try {
					const timeline = this.$refs.timeline;
					const currentWindow = timeline.getWindow();
					if (currentWindow && currentWindow.start && currentWindow.end) {
						startDate = new Date(currentWindow.start);
						endDate = new Date(currentWindow.end);
					} else {
						startDate = this.timelineStart;
						endDate = this.timelineEnd;
					}
				} catch (error) {
					startDate = this.timelineStart;
					endDate = this.timelineEnd;
				}
			}
			else if (this.search && this.search.start && this.search.end) {
				startDate = this.parseCustomDateFormat(this.search.start);
				endDate = this.parseCustomDateFormat(this.search.end);
			} 
			else if (params && params.start && params.end) {
				startDate = this.parseCustomDateFormat(params.start);
				endDate = this.parseCustomDateFormat(params.end);
			} 
			else {
				startDate = this.timelineStart;
				endDate = this.timelineEnd;
			}

			if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
				startDate = this.timelineStart;
				endDate = this.timelineEnd;
			}

			let timelineScale = null;
			if (this.isTimelineReady()) {
				try {
					const scaleInfo = this.getTimelineScale();
					if (scaleInfo) {
						timelineScale = {
							zoomLevel: this.getZoomLevel(),
							pixelsPerSecond: scaleInfo.scale.pixelsPerSecond,
							canvasWidth: scaleInfo.canvas.width,
							canvasHeight: scaleInfo.canvas.height
						};
					}
				} catch (error) {
					console.warn('Error getting timeline scale:', error);
				}
			}

			const analyticsPayload = {
				start: this.formatDateForBackend(startDate),
				end: this.formatDateForBackend(endDate),
				deviceId: params?.deviceId || this.search?.deviceId || null,
				timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				timelineScale: timelineScale || {
					zoomLevel: "medium",
					pixelsPerSecond: 1.0,
					canvasWidth: 1200,
					canvasHeight: 400
				},
				groupingParams: {
					timeUnit: this.getAdaptiveTimeUnit(),
					adaptiveGrouping: true,
					groupActive: this.groupActive
				},
				eventFilters: {
					groups: (params?.groups && params.groups.length > 0) 
						? params.groups 
						: ((this.search?.groups && this.search.groups.length > 0) 
							? this.search.groups 
							: ["LPR", "Actions", "SmartEvent", "Records", "Alerts", "Objects", "Axle", "Counter"])
				},
				requestReason: params?.requestReason || 'timeline_change',
				isAutomaticRequest: !isManual
			};

			const apiUrl = this.$URL + "/api/v1/records/find_analytics";
			
			this.$axios.post(apiUrl, analyticsPayload).then(response => {
				if (response.data) {
					this.processAnalyticsResponse(response.data, {
						isRangeChange: isRangeChange,
						startDate: startDate,
						endDate: endDate,
						requestReason: params?.requestReason
					});
				} else {
					console.warn('No data received from find_analytics endpoint');
					this.loading_timeline = false;
					this.setDefault();
				}
				
				if (isManual) {
					this.deactivateManualSearchFlag();
				}
			}).catch(error => { 
				console.error('Error calling find_analytics endpoint:', error);
				this.loading_timeline = false;
				
				if (isManual) {
					this.deactivateManualSearchFlag();
				}
			});
		},

		// Método para verificar si una búsqueda es manual (simplificado)
		isManualSearch(params) {
			return params?.isManualSearch || 
				   (params && (params.start || params.end)) ||
				   (this.search && this.search.start && this.search.end);
		},

		// Método para desactivar el flag de búsqueda manual
		deactivateManualSearchFlag() {
			setTimeout(() => {
				this.isManualSearchInProgress = false;
			}, this.manualSearchCooldown);
		},




		// Métodos de utilidad
		isTimelineReady() {
			return !!(this.$refs && this.$refs.timeline);
		},





		// Método alternativo para actualizar el timeline usando la API de vis.js




		getZoomLevel() {
			if (!this.$refs || !this.$refs.timeline) {
				return 'medium';
			}
			
			try {
				const scaleInfo = this.getTimelineScale();
				if (!scaleInfo) return 'medium';
				
				const pixelsPerSecond = scaleInfo.scale.pixelsPerSecond;
				
				if (pixelsPerSecond > 10) return 'high';
				if (pixelsPerSecond > 1) return 'medium';
				return 'low';
			} catch (error) {
				return 'medium';
			}
		},

		getPixelsPerSecond() {
			if (!this.$refs || !this.$refs.timeline) {
				return 2.5;
			}
			
			try {
				const scaleInfo = this.getTimelineScale();
				if (!scaleInfo) return 2.5;
				
				return scaleInfo.scale.pixelsPerSecond;
			} catch (error) {
				return 2.5;
			}
		},

		getAdaptiveTimeUnit() {
			if (this.isTimelineReady() && this.$refs.timeline) {
				try {
					const timeline = this.$refs.timeline;
					const currentWindow = timeline.getWindow();
					const durationMs = currentWindow.end - currentWindow.start;
					const durationHours = durationMs / (1000 * 60 * 60);
					const durationDays = durationHours / 24;
					const durationMinutes = durationMs / (1000 * 60);
					const durationSeconds = durationMs / 1000;
					
					if (durationSeconds <= 60) return 'millisecond';
					if (durationMinutes <= 5) return 'second';
					if (durationMinutes <= 30) return 'second';
					if (durationHours <= 2) return 'minute';
					if (durationHours <= 6) return 'minute';
					if (durationHours <= 12) return 'hour';
					if (durationHours <= 48) return 'hour';
					if (durationDays <= 7) return 'day';
					if (durationDays <= 30) return 'day';
					return 'week';
				} catch (error) {
					// Fallback
				}
			}
			
			const pixelsPerSecond = this.getPixelsPerSecond();
			
			if (pixelsPerSecond > 50) return 'millisecond';
			if (pixelsPerSecond > 20) return 'second';
			if (pixelsPerSecond > 10) return 'minute';
			if (pixelsPerSecond > 1) return 'hour';
			if (pixelsPerSecond > 0.1) return 'day';
			return 'week';
		},

		// Métodos de formateo de fechas
		parseCustomDateFormat(dateString) {
			if (!dateString || typeof dateString !== 'string') {
				return new Date();
			}

			try {
				const parts = dateString.split('_');
				if (parts.length !== 2) {
					return new Date();
				}

				const datePart = parts[0];
				const timePart = parts[1];

				const [year, month, day] = datePart.split('/').map(Number);
				const [hour, minute, second] = timePart.split('-').map(Number);

				const date = new Date(year, month - 1, day, hour, minute, second);
				return date;
			} catch (error) {
				return new Date();
			}
		},

		formatDateForBackend(date) {
			try {
				let d;
				
				if (date instanceof Date) {
					d = date;
				} else if (typeof date === 'string') {
					d = new Date(date);
				} else if (typeof date === 'number') {
					d = new Date(date);
				} else {
					d = new Date();
				}
				
				if (isNaN(d.getTime())) {
					d = new Date();
				}
				
				const year = d.getFullYear();
				const month = String(d.getMonth() + 1).padStart(2, '0');
				const day = String(d.getDate()).padStart(2, '0');
				const hours = String(d.getHours()).padStart(2, '0');
				const minutes = String(d.getMinutes()).padStart(2, '0');
				const seconds = String(d.getSeconds()).padStart(2, '0');
				
				return `${year}/${month}/${day}_${hours}-${minutes}-${seconds}`;
				
			} catch (error) {
				const fallbackDate = new Date();
				const year = fallbackDate.getFullYear();
				const month = String(fallbackDate.getMonth() + 1).padStart(2, '0');
				const day = String(fallbackDate.getDate()).padStart(2, '0');
				const hours = String(fallbackDate.getHours()).padStart(2, '0');
				const minutes = String(fallbackDate.getMinutes()).padStart(2, '0');
				const seconds = String(fallbackDate.getSeconds()).padStart(2, '0');
				
				return `${year}/${month}/${day}_${hours}-${minutes}-${seconds}`;
			}
		},

		formatDateToYYYYMMDD(date) {
			const d = new Date(date);
			const year = d.getFullYear();
			const month = String(d.getMonth() + 1).padStart(2, '0');
			const day = String(d.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},


		processAnalyticsResponse(data, context = null) {
			// Optimización: Limpiar items anteriores de forma eficiente
			// Simplemente reemplazar el array es más rápido que iterar y limpiar
			this.items = [];
			
			try {
				let recordingsToProcess = [];
				
				if (data.timeline && Array.isArray(data.timeline)) {
					recordingsToProcess = data.timeline;
				}
				else if (data.rows && Array.isArray(data.rows)) {
					recordingsToProcess = data.rows;
				}
				else if (data.recordings && Array.isArray(data.recordings)) {
					recordingsToProcess = data.recordings;
				}
				
				if (recordingsToProcess.length > 0) {
					this.processRecordingsFromAnalytics(recordingsToProcess);
				}
				
				if (data.analityc) {
					if (data.analityc.lpr && Array.isArray(data.analityc.lpr)) {
						this.processEvents(data.analityc.lpr, 'lpr');
					}
					
					if (data.analityc.objects && Array.isArray(data.analityc.objects)) {
						this.processEvents(data.analityc.objects, 'objects');
					}
					
					if (data.analityc.action && Array.isArray(data.analityc.action)) {
						this.processEvents(data.analityc.action, 'action');
					}
					
					if (data.analityc.alert && Array.isArray(data.analityc.alert)) {
						this.processAlerts(data.analityc.alert);
					}
					
					if (data.analityc.smartEvent && Array.isArray(data.analityc.smartEvent)) {
						this.processSmartEvents(data.analityc.smartEvent);
					} else {
						console.log('No smart events found in API response');
					}
				}
				
				if (this.items.length === 0) {
					this.setDefault();
				}
				
				// Aplicar heatmap basado en la cantidad de eventos
				this.applyHeatmapToItems();
				
				const skipSync = context && context.isRangeChange;
				
				if (typeof this.updateTimeline === 'function') {
					this.updateTimeline(skipSync).then(() => {
						// Timeline updated
					}).catch(error => {
						// Error updating timeline
					});
				} else {
					if (this.$refs && this.$refs.timeline) {
						this.$refs.timeline.redraw();
					}
				}
			} catch (error) {
				this.setDefault();
			} finally {
				this.loading_timeline = false;
				// Optimización: Emitir evento solo una vez al final
				this.$nextTick(() => {
					this.$emit('items-updated', this.items);
				});
			}
		},

		// Método para procesar grabaciones del endpoint find_analytics
		// Optimizado: Acumula items en array temporal antes de asignar
		processRecordingsFromAnalytics(recordings) {
			if (!recordings || recordings.length === 0) return;

			// Optimización: Pre-allocar array con tamaño aproximado para mejor rendimiento
			const processedItems = [];
			const recordingsLength = recordings.length;
			
			// Optimización: Usar for loop en lugar de forEach para mejor rendimiento
			for (let index = 0; index < recordingsLength; index++) {
				const recording = recordings[index];
				try {
					// Parsear fechas desde el formato que viene del endpoint find_analytics
					let recordingStart, recordingEnd;
					
					// Optimización: Usar timestamp directamente si está disponible (más rápido que parsear strings)
					if (recording.startTimestamp) {
						recordingStart = new Date(recording.startTimestamp);
					} else if (recording.start && typeof recording.start === 'number') {
						recordingStart = new Date(recording.start);
					} else if (recording.start && typeof recording.start === 'string') {
						recordingStart = new Date(recording.start);
					} else if (recording.unix_itme_stamp) {
						recordingStart = new Date(parseInt(recording.unix_itme_stamp));
					} else {
						continue; // Saltar si no hay fecha válida
					}
					
					if (recording.endTimestamp) {
						recordingEnd = new Date(recording.endTimestamp);
					} else if (recording.end && typeof recording.end === 'number') {
						recordingEnd = new Date(recording.end);
					} else if (recording.end && typeof recording.end === 'string') {
						recordingEnd = new Date(recording.end);
					} else {
						recordingEnd = new Date(recordingStart.getTime() + 20000);
					}
					
					// Validar fechas
					if (isNaN(recordingStart.getTime()) || isNaN(recordingEnd.getTime())) {
						continue;
					}
					
					// Calcular duración real
					const duration = recordingEnd.getTime() - recordingStart.getTime();
					
					// Determinar el tipo de evento y grupo (optimizado con early returns)
					let eventGroup = recording.group || 3;
					let eventContent = `📹 ${recording.id || 'Recording'}`;
					let eventClassName = 'recording-item';
					let isAlert = false;
					let isSmartEvent = false;
					let isLPR = false;
					let isAction = false;
					let isAxle = false;
					let isCounter = false;
					
					const idPrefix = recording.id ? recording.id.substring(0, 6) : '';
					
					// Verificar primero por grupo asignado (si el backend ya lo asignó)
					if (recording.group === 6 || recording.group === '6') {
						eventGroup = 6;
						eventContent = `🛞 ${recording.title || recording.id || 'Axle'}`;
						eventClassName = 'axle-item';
						isAxle = true;
					} else if (recording.group === 7 || recording.group === '7') {
						eventGroup = 7;
						eventContent = `🔢 ${recording.title || recording.id || 'Counter'}`;
						eventClassName = 'counter-item';
						isCounter = true;
					} else if (idPrefix === 'alert') {
						eventGroup = 5;
						eventContent = `🚨 ${recording.title || 'Alert'}`;
						eventClassName = 'alert-item';
						isAlert = true;
					} else if (idPrefix === 'smartE') {
						eventGroup = 4;
						eventContent = `🧠 ${recording.title || 'Smart Event'}`;
						eventClassName = 'smart-event-item';
						isSmartEvent = true;
					} else if (idPrefix === 'lpr') {
						eventGroup = 0;
						eventContent = `🚗 ${recording.title || 'LPR'}`;
						eventClassName = 'lpr-item';
						isLPR = true;
					} else if (idPrefix === 'action') {
						eventGroup = 2;
						eventContent = `⚡ ${recording.title || 'Action'}`;
						eventClassName = 'action-item';
						isAction = true;
					} else if (idPrefix === 'record') {
						eventGroup = 3;
						eventContent = `📹 ${recording.id || 'Recording'}`;
						eventClassName = 'recording-item';
					} else if (idPrefix === 'axle') {
						eventGroup = 6;
						eventContent = `🛞 ${recording.title || 'Axle'}`;
						eventClassName = 'axle-item';
						isAxle = true;
					} else if (idPrefix === 'counte') {
						eventGroup = 7;
						eventContent = `🔢 ${recording.title || 'Counter'}`;
						eventClassName = 'counter-item';
						isCounter = true;
					}
					
					// Crear metadata ligera
					const eventCount = recording.eventCount || recording.cantidadEventos || 0;
					const isBucket = recording.isBucket || false;
					
					const recordingMetadata = {
						isRecording: !isAlert && !isSmartEvent && !isLPR && !isAction && !isAxle && !isCounter,
						isAlert: isAlert,
						isSmartEvent: isSmartEvent,
						isLPR: isLPR,
						isAction: isAction,
						isAxle: isAxle,
						isCounter: isCounter,
						recordingType: isAlert ? 'alert' : (isSmartEvent ? 'smartEvent' : (isLPR ? 'lpr' : (isAction ? 'action' : (isAxle ? 'axle' : (isCounter ? 'counter' : 'video'))))),
						recordingId: recording.id || null,
						recordingStart: recordingStart,
						recordingEnd: recordingEnd,
						recordingDuration: duration,
						evidence: recording.evidence || null,
						deviceId: recording.deviceId || null,
						unixTimestamp: recording.unix_itme_stamp || null,
						type: recording.type || null,
						title: recording.title || null,
						subgroup: recording.subgroup || null,
						isBucket: isBucket,
						eventCount: eventCount
					};
					
					// Crear título para tooltip: mostrar eventCount si es Records y tiene eventos
					let itemTitle = '';
					if (eventGroup === 3 && isBucket && eventCount > 0) {
						// Formatear fecha para el tooltip
						const startDateStr = recordingStart.toLocaleString('es-ES', {
							year: 'numeric',
							month: '2-digit',
							day: '2-digit',
							hour: '2-digit',
							minute: '2-digit',
							second: '2-digit'
						});
						const endDateStr = recordingEnd.toLocaleString('es-ES', {
							hour: '2-digit',
							minute: '2-digit',
							second: '2-digit'
						});
						const durationSec = Math.round(duration / 1000);
						itemTitle = `Records\n${eventCount} ${eventCount === 1 ? 'evento' : 'eventos'}\n${startDateStr} - ${endDateStr}\nDuración: ${durationSec}s`;
					}
					
					processedItems.push({
						id: recording.id || `recording_${index}`,
						group: eventGroup,
						start: recordingStart,
						end: recordingEnd,
						content: eventContent,
						className: eventClassName,
						title: itemTitle,
						metadata: recordingMetadata
					});
					
				} catch (error) {
					console.error(`Error processing recording ${recording.id}:`, error);
				}
			}
			
			// Optimización: Asignar todos los items de una vez en lugar de push individual
			this.items.push(...processedItems);
		},


		processEvents(events, eventType = null) {
			if (!events || events.length === 0) return;
			
			if (eventType === 'lpr') {
				this.processLPREvents(events);
				return;
			}
			
			if (eventType === 'objects') {
				this.processObjectsEvents(events);
				return;
			}
			
			events.forEach((event, index) => {
				const eventStart = new Date(event.timestamp || event.date || Date.now());
				const eventEnd = new Date(eventStart.getTime() + (event.duration || 1000));
				
				const eventItemId = `event_${event.id || index}`;
				
				// Crear metadata ligera sin guardar el objeto completo
				const eventMetadata = {
					isEvent: true,
					eventType: eventType || event.type || null,
					eventId: event.id || null,
					eventStart: eventStart,
					eventEnd: eventEnd,
					eventDuration: event.duration || 1000
				};
				
				const eventItem = {
					id: eventItemId,
					group: this.getEventGroupId(eventType || event.type),
					start: eventStart,
					end: eventEnd,
					content: `📊 ${eventType || event.type || 'Event'}`,
					className: 'event-item',
					title: '',
					metadata: eventMetadata
				};
				
				this.items.push(eventItem);

			});
		},

		// Método específico para procesar eventos LPR
		processLPREvents(lprEvents) {
			if (!lprEvents || lprEvents.length === 0) return;
			
			lprEvents.forEach((event, index) => {
				// Crear metadata ligera sin guardar el objeto completo del backend
				const lprMetadata = {
					isEvent: true,
					isLPR: true,
					eventType: 'lpr',
					eventId: event.id || null,
					plateNumber: event.content || null,
					evidence: event.evidence || null,
					unixTimestamp: event.unix_itme_stamp || null,
					isAlert: false,
					isSmartEvent: false,
					isAction: false,
					isRecording: false,
					recordingType: 'lpr',
					recordingId: event.id || null,
					recordingStart: new Date(event.start),
					recordingEnd: new Date(new Date(event.start).getTime() + 1000),
					recordingDuration: 1000,
					deviceId: event.deviceId || null,
					type: event.type || null,
					title: event.title || null,
					subgroup: event.subgroup || null
				};
				
				const eventItem = {
					id: event.id || `lpr_${index}`,
					group: event.group || 0, // Grupo LPR
					start: new Date(event.start),
					end: new Date(new Date(event.start).getTime() + 1000), // Duración de 1 segundo
					content: event.content || 'LPR Event',
					className: 'lpr-item',
					title: event.title || `LPR: ${event.content || 'Unknown'}`,
					metadata: lprMetadata
				};
				
				this.items.push(eventItem);
			});
		},

		processObjectsEvents(objectEvents) {
			if (!objectEvents || objectEvents.length === 0) return;
			
			objectEvents.forEach((event, index) => {
				try {
					let eventStart, eventEnd;
					
					// PRIORIDAD 1: Usar start y end directamente (campos principales del API)
					if (event.start) {
						eventStart = typeof event.start === 'number' ? new Date(event.start) : new Date(event.start);
					} else if (event.startTimestamp) {
						eventStart = new Date(event.startTimestamp);
					} else if (event.timestamp) {
						eventStart = new Date(event.timestamp);
					} else if (event.date) {
						eventStart = new Date(event.date);
					} else if (event.unix_itme_stamp) {
						eventStart = new Date(parseInt(event.unix_itme_stamp));
					} else {
						eventStart = new Date(Date.now() + (index * 1000));
					}
					
					// PRIORIDAD 1: Usar end directamente (campo principal del API)
					if (event.end) {
						eventEnd = typeof event.end === 'number' ? new Date(event.end) : new Date(event.end);
					} else if (event.endTimestamp) {
						eventEnd = new Date(event.endTimestamp);
					} else if (event.duration) {
						eventEnd = new Date(eventStart.getTime() + event.duration);
					} else if (event.bucketDuration) {
						eventEnd = new Date(eventStart.getTime() + event.bucketDuration);
					} else {
						eventEnd = new Date(eventStart.getTime() + 5000);
					}
					
					if (isNaN(eventStart.getTime()) || isNaN(eventEnd.getTime())) {
						console.warn(`Objeto ${index} tiene fechas inválidas:`, event);
						return;
					}
					
					const objectType = event.title || event.type || event.name || 'unknown';
					// Usar el subgroup del API si está disponible, sino calcularlo
					const subgroup = event.subgroup || this.getObjectSubgroup(objectType);
					const objectItemId = event.id || `object_${index}`;
					
					const existingObject = this.items.find(item => item.id === objectItemId && item.group === 1);
					if (existingObject) {
						return;
					}
					const eventSize = JSON.stringify(event).length;
					const metadataSize = JSON.stringify({
						isObject: true,
						isBucket: event.isBucket || false,
						eventCount: event.eventCount || event.cantidadEventos || null,
						objectType: objectType,
						objectId: event.id || index
					}).length;
					
					// Crear metadata ligera sin guardar el objeto completo del backend
					const objectMetadata = {
						isObject: true,
						isBucket: event.isBucket || false,
						eventCount: event.eventCount || event.cantidadEventos || null,
						objectType: objectType,
						objectId: event.id || index,
						objectStart: eventStart,
						objectEnd: eventEnd,
						objectDuration: eventEnd.getTime() - eventStart.getTime(),
						subgroup: subgroup,
						confidence: event.confidence || event.score || null,
						deviceId: event.deviceId || null,
						evidence: event.evidence || null,
						unixTimestamp: event.unix_itme_stamp || event.startTimestamp || event.timestamp,
						// Campos necesarios para buscar eventos del bucket
						startTimestamp: event.startTimestamp || event.start || (typeof eventStart === 'object' ? eventStart.getTime() : eventStart),
						endTimestamp: event.endTimestamp || event.end || (typeof eventEnd === 'object' ? eventEnd.getTime() : eventEnd)
					};
					
					// Solo incluir bbox si es necesario y pequeño (máximo 4 valores)
					if (event.bbox && Array.isArray(event.bbox) && event.bbox.length <= 4) {
						objectMetadata.bbox = event.bbox;
					}
					
					const objectItem = {
						id: objectItemId,
						group: 1, // Grupo Objects
						subgroup: subgroup,
						start: eventStart,
						end: eventEnd,
						content: `🎯 ${objectType}`,
						className: `event-item object-item object-${subgroup}`,
						title: `Objeto: ${objectType}`,
						metadata: objectMetadata
					};
					
					this.items.push(objectItem);
					
				} catch (error) {
					console.error(`Error procesando objeto ${index}:`, error);
				}
			});
		},

		processAlerts(alerts) {
			if (!alerts || alerts.length === 0) return;
			
			alerts.forEach((alert, index) => {
				const alertStart = new Date(alert.start);
				const alertEnd = new Date(alert.end);
				const category = alert.category || alert.name_categorie || 'Unknown';
				
				if (isNaN(alertStart.getTime()) || isNaN(alertEnd.getTime())) {
					console.warn(`Invalid dates for alert ${alert.id}:`, alert.start, alert.end);
					return;
				}
				
				// Crear metadata ligera sin guardar el objeto completo del backend
				const alertMetadata = {
					isAlert: true,
					alertType: alert.title || alert.type || null,
					alertId: alert.id || null,
					alertStart: alertStart,
					alertEnd: alertEnd,
					alertDuration: alertEnd.getTime() - alertStart.getTime(),
					evidence: alert.evidence || null,
					subgroup: alert.subgroup || null,
					unixTimestamp: alert.unix_itme_stamp || null
				};
				
				const alertItem = {
					id: alert.id || `alert_${index}`,
					group: 5,
					start: alertStart,
					end: alertEnd,
					content: `🚨 ${alert.title} - ${category}`,
					className: 'alert-item',
					title: '',
					metadata: alertMetadata
				};
				
				this.items.push(alertItem);
			});
		},

		// Método para mapear categorías de smart events a subgrupos
		getSmartEventSubgroup(category) {
			// Si la categoría ya existe, devolver su subgrupo asignado
			if (this.subgroupStack[category]) {
				return this.subgroupStack[category];
			}
			
			// Si es nueva, asignar el siguiente número de subgrupo
			const nextSubgroupNumber = Object.keys(this.subgroupStack).length + 1;
			this.subgroupStack[category] = `sg_${nextSubgroupNumber}`;
			 return this.subgroupStack[category];
			
		},

		getObjectSubgroup(objectType) {
			const normalizedType = (objectType || '').toLowerCase();
			
			const objectSubgroupMap = {
				'aeroplane': 'sg_1',
				'airplane': 'sg_1',
				'avion': 'sg_1',
				'car': 'sg_2', 
				'auto': 'sg_2',
				'coche': 'sg_2',
				'person': 'sg_3',
				'persona': 'sg_3',
				'people': 'sg_3',
				'train': 'sg_4',
				'tren': 'sg_4',
				'suitcase': 'sg_5',
				'maleta': 'sg_5',
				'bag': 'sg_5',
				'bus': 'sg_6',
				'autobus': 'sg_6',
				'truck': 'sg_7',
				'camion': 'sg_7',
				'motorcycle': 'sg_8',
				'moto': 'sg_8',
				'bike': 'sg_8',
				'bicycle': 'sg_8',
				'bicicleta': 'sg_8'
			};
			
			if (objectSubgroupMap[normalizedType]) {
				return objectSubgroupMap[normalizedType];
			}
			
			for (const [key, value] of Object.entries(objectSubgroupMap)) {
				if (normalizedType.includes(key) || key.includes(normalizedType)) {
					return value;
				}
			}
			
			return 'sg_1';
		},

		// Método para procesar smart events
		applyHeatmapToItems() {
			// Optimización: Si no hay items, salir temprano
			if (!this.items || this.items.length === 0) {
				return;
			}
			
			// Optimización: Agrupar items y calcular máximos en una sola pasada
			const itemsByGroup = {};
			const maxCountsByGroup = {};
			
			// Primera pasada: agrupar y encontrar máximos simultáneamente
			const itemsLength = this.items.length;
			for (let i = 0; i < itemsLength; i++) {
				const item = this.items[i];
				const groupId = item.group;
				
				// Solo procesar buckets con eventCount
				const eventCount = item.metadata?.eventCount || item.metadata?.cantidadEventos || 0;
				if (eventCount > 0 || item.metadata?.isBucket) {
					if (!itemsByGroup[groupId]) {
						itemsByGroup[groupId] = [];
						maxCountsByGroup[groupId] = 0;
					}
					itemsByGroup[groupId].push(item);
					if (eventCount > maxCountsByGroup[groupId]) {
						maxCountsByGroup[groupId] = eventCount;
					}
				}
			}
			
			// Segunda pasada: aplicar estilos solo a los buckets
			const groupIds = Object.keys(itemsByGroup);
			for (let g = 0; g < groupIds.length; g++) {
				const groupId = groupIds[g];
				const groupItems = itemsByGroup[groupId];
				const maxEventCount = maxCountsByGroup[groupId];
				
				if (maxEventCount === 0) continue;
				
				const groupItemsLength = groupItems.length;
				for (let i = 0; i < groupItemsLength; i++) {
					const item = groupItems[i];
					const eventCount = item.metadata?.eventCount || item.metadata?.cantidadEventos || 0;
					
					// Calcular opacidad: mínimo 0.3 (30%), máximo 1.0 (100%)
					const opacity = Math.max(0.3, Math.min(1.0, eventCount / maxEventCount));
					
					// Optimización: Solo actualizar si el estilo cambió para evitar repaints innecesarios
					const newOpacity = opacity.toFixed(2);
					const currentOpacity = item.style?.match(/opacity:\s*([\d.]+)/)?.[1];
					
					if (currentOpacity !== newOpacity) {
						// Obtener el color base del className
						const baseColor = this.getBaseColorForItem(item);
						
						// Aplicar opacidad al color
						const colorWithOpacity = this.applyOpacityToColor(baseColor, opacity);
						
						// Optimización: Usar opacity en lugar de cambiar background-color para mejor rendimiento
						// Solo actualizar si realmente cambió
						item.style = `background-color: ${colorWithOpacity}; border-color: ${colorWithOpacity}; opacity: ${newOpacity}`;
					}
				}
			}
		},
		
		getBaseColorForItem(item) {
			// Obtener el color base según el className del item
			// Smart Events - Verde
			if (item.className && item.className.includes('smart-event-item')) {
				// Usar el color del subgroup si está disponible
				if (item.subgroup === 'sg_1') return '#1b5e20';
				if (item.subgroup === 'sg_2') return '#2e7d32';
				if (item.subgroup === 'sg_3') return '#4caf50';
				if (item.subgroup === 'sg_4') return '#8bc34a';
				return '#4caf50'; // Verde por defecto para smart events
			}
			
			// Objects - Verde (similar a smart events)
			if (item.className && item.className.includes('object-item')) {
				return '#4caf50';
			}
			
			// Recordings - Azul
			if (item.className && item.className.includes('recording-item')) {
				return '#42a5f5';
			}
			
			// Alerts - Rojo
			if (item.className && item.className.includes('alert-item')) {
				return '#ef5350';
			}
			
			// LPR - Púrpura
			if (item.className && item.className.includes('lpr-item')) {
				return '#4a148c';
			}
			
			// Por defecto, verde
			return '#4caf50';
		},
		
		applyOpacityToColor(color, opacity) {
			// Si el color ya es rgba, extraer los valores RGB y aplicar nueva opacidad
			if (color.startsWith('rgba') || color.startsWith('rgb')) {
				const matches = color.match(/\d+/g);
				if (matches && matches.length >= 3) {
					const r = parseInt(matches[0]);
					const g = parseInt(matches[1]);
					const b = parseInt(matches[2]);
					return `rgba(${r}, ${g}, ${b}, ${opacity})`;
				}
			}
			
			// Si es un color hexadecimal, convertirlo a rgba
			if (color.startsWith('#')) {
				const hex = color.replace('#', '');
				const r = parseInt(hex.substring(0, 2), 16);
				const g = parseInt(hex.substring(2, 4), 16);
				const b = parseInt(hex.substring(4, 6), 16);
				return `rgba(${r}, ${g}, ${b}, ${opacity})`;
			}
			
			// Si no se puede parsear, devolver el color original con opacidad
			return color;
		},

		processSmartEvents(smartEvents) {
			if (!smartEvents || smartEvents.length === 0) return;
			
			// 🚀 INICIO: Medición de rendimiento de smart events
			const smartEventsStartTime = performance.now();
			
			
			smartEvents.forEach((smartEvent, index) => {
				let eventStart, eventEnd;
				
				// PRIORIDAD 1: Usar start y end directamente (campos principales del API)
				if (smartEvent.start) {
					eventStart = typeof smartEvent.start === 'number' ? new Date(smartEvent.start) : new Date(smartEvent.start);
				} else if (smartEvent.startTimestamp) {
					eventStart = new Date(smartEvent.startTimestamp);
				} else if (smartEvent.unix_itme_stamp) {
					const timestamp = parseInt(smartEvent.unix_itme_stamp);
					eventStart = new Date(timestamp);
				} else {
					eventStart = new Date(Date.now() + (index * 1000));
				}
				
				// PRIORIDAD 1: Usar end directamente (campo principal del API)
				if (smartEvent.end) {
					eventEnd = typeof smartEvent.end === 'number' ? new Date(smartEvent.end) : new Date(smartEvent.end);
				} else if (smartEvent.endTimestamp) {
					eventEnd = new Date(smartEvent.endTimestamp);
				} else if (smartEvent.duration) {
					eventEnd = new Date(eventStart.getTime() + smartEvent.duration);
				} else if (smartEvent.bucketDuration) {
					eventEnd = new Date(eventStart.getTime() + smartEvent.bucketDuration);
				} else {
					eventEnd = new Date(eventStart.getTime() + 10000);
				}
				
				if (isNaN(eventStart.getTime()) || isNaN(eventEnd.getTime())) {
					console.warn(`Smart event ${index} tiene fechas inválidas:`, smartEvent);
					return;
				}
				
				const category = smartEvent.category || smartEvent.name_categorie || 'Unknown';
				// Usar el subgroup del API si está disponible, sino calcularlo
				const subgroup = smartEvent.subgroup || this.getSmartEventSubgroup(category);
				
				// Construir contenido: si es un bucket, mostrar cantidad de eventos
				let content = `${category}  ${smartEvent.title || ''}`;
				if (smartEvent.isBucket && smartEvent.eventCount) {
					content = `${category}  ${smartEvent.title || ''} (${smartEvent.eventCount})`;
				}
				
				// Crear metadata ligera sin referencias grandes al evento original
				const smartEventMetadata = {
					isSmartEvent: true,
					isBucket: smartEvent.isBucket || false,
					eventCount: smartEvent.eventCount || smartEvent.cantidadEventos || null,
					eventType: smartEvent.type || smartEvent.tag || null,
					eventId: smartEvent.id || null,
					eventStart: eventStart,
					eventEnd: eventEnd,
					eventDuration: eventEnd.getTime() - eventStart.getTime(),
					category: category,
					subgroup: subgroup,
					unixTimestamp: smartEvent.unix_itme_stamp || smartEvent.startTimestamp || null
				};
				
				const smartEventItem = {
					id: smartEvent.id || `smart_event_${index}`,
					group: smartEvent.group || 4,
					subgroup: subgroup,
					start: eventStart,
					end: eventEnd,
					content: content,
					className: `smart-event-item smart-event-${subgroup}`,
					title: `Smart Event: ${category}${smartEvent.isBucket && smartEvent.eventCount ? ` (${smartEvent.eventCount} eventos)` : ''}`,
					metadata: smartEventMetadata
				};
				
				this.items.push(smartEventItem);
			});
		},

		getEventGroupId(eventType) {
			const groupMap = {
				'lpr': 0,
				'LPR': 0,
				'objects': 1,
				'Objects': 1,
				'action': 2,
				'Actions': 2,
				'smartEvent': 4,
				'SmartEvent': 4,
				'alert': 5,
				'Alerts': 5,
				'axle': 6,
				'Axle': 6,
				'counter': 7,
				'Counter': 7
			};
			
			return groupMap[eventType] || 1;
		},

		async findClosestVideoByTimestamp(timestamp, deviceId = null) {
			if (!timestamp) {
				return null;
			}

			try {
				if (!deviceId && this.search && this.search.deviceId) {
					deviceId = this.search.deviceId;
				}

				if (!deviceId) {
					return null;
				}

				const payload = {
					timestamp: timestamp,
					deviceId: deviceId
				};

				const apiUrl = this.$URL + "/api/v1/records/find_closest_video";
				const response = await this.$axios.post(apiUrl, payload);

				if (response && response.data) {
					this.$emit('closest_video_found', {
						timestamp: timestamp,
						deviceId: deviceId,
						videoData: response.data,
						searchContext: {
							requestedTime: new Date(timestamp).toISOString(),
							deviceId: deviceId
						}
					});

					return {
						success: true,
						videoData: response.data,
						timestamp: timestamp,
						deviceId: deviceId,
						searchResult: {
							message: "Video encontrado exitosamente",
							requestedTime: new Date(timestamp).toISOString(),
							videoInfo: response.data
						}
					};
				} else {
					return {
						success: false,
						message: "No se encontró video para el timestamp especificado",
						timestamp: timestamp,
						deviceId: deviceId
					};
				}

			} catch (error) {
				this.$emit('closest_video_error', {
					timestamp: timestamp,
					deviceId: deviceId,
					error: error.message || 'Error desconocido'
				});

				return {
					success: false,
					error: error.message || 'Error desconocido',
					timestamp: timestamp,
					deviceId: deviceId
				};
			}
		},

		openVideoInMainPlayer(videoData, timestamp = null) {
			try {
				if (this.refVideoPlayToComponent) {
					const video = videoData.video || videoData.closestVideo;
					if (video && video.urlpath) {
						const videoUrl = this.$URL + video.urlpath;
						
						if (this.refVideoPlayToComponent.src !== undefined) {
							this.refVideoPlayToComponent.src = videoUrl;
						} else if (this.refVideoPlayToComponent.currentSrc !== undefined) {
							this.refVideoPlayToComponent.currentSrc = videoUrl;
						}
						
						if (typeof this.refVideoPlayToComponent.load === 'function') {
							this.refVideoPlayToComponent.load();
						}
						
						if (typeof this.refVideoPlayToComponent.play === 'function') {
							setTimeout(() => {
								this.refVideoPlayToComponent.play().catch(error => {
									// Error playing video
								});
							}, 1000);
						}
						
						this.$emit('video_opened_in_main_player', {
							videoData: videoData,
							videoUrl: videoUrl,
							timestamp: timestamp,
							playerComponent: this.refVideoPlayToComponent
						});
						
						this.$emit('receive_url_video', videoUrl);
					}
				} else {
					this.$emit('video_needs_opening', {
						videoData: videoData,
						timestamp: timestamp,
						message: "Reproductor principal no disponible, necesita apertura manual"
					});
				}
			} catch (error) {
				this.$emit('video_open_error', {
					videoData: videoData,
					timestamp: timestamp,
					error: error.message || 'Error desconocido'
				});
			}
		},

		updateTimeline(skipSync = false) {
			return new Promise((resolve, reject) => {
				if (this.isTimelineReady()) {
					this.updateTimelineInternal(skipSync).then(resolve).catch(reject);
					return;
				}
				
				this.waitForTimeline(50, 200).then(() => {
					this.updateTimelineInternal(skipSync).then(resolve).catch(reject);
				}).catch(error => {
					resolve(true);
				});
			});
		},

		updateTimelineInternal(skipSync = false) {
			return new Promise((resolve, reject) => {
				try {
					this.loading_timeline = false;
					
					if (this.isTimelineReady() && this.$refs.timeline) {
						// Optimización: Solo actualizar datos una vez, no múltiples veces
						if (typeof this.$refs.timeline.setItems === 'function') {
							this.$refs.timeline.setItems(this.items);
							// setItems ya actualiza, no necesitamos redraw inmediatamente
						} else if (typeof this.$refs.timeline.setData === 'function') {
							this.$refs.timeline.setData({ items: this.items, groups: this.groups });
							// setData ya actualiza, redraw solo si es necesario
							if (typeof this.$refs.timeline.redraw === 'function') {
								this.$refs.timeline.redraw();
							}
						} else if (typeof this.$refs.timeline.redraw === 'function') {
							this.$refs.timeline.redraw();
						}
					}
					
					let startDate, endDate;
					
					const validatedDates = this.validateSearchDates(this.search);
					startDate = validatedDates.startDate;
					endDate = validatedDates.endDate;
					
					if (this.isTimelineReady() && !skipSync) {
						setTimeout(() => {
							this.syncTimelineWithDates(startDate, endDate);
						}, 500);
						
						setTimeout(() => {
							if (this.$refs && this.$refs.timeline) {
								this.getTimelineScale();
							}
						}, 2000);
					}
					
					resolve(true);
				} catch (error) {
					reject(error);
				}
			});
		},

		waitForTimeline(maxAttempts = 50, delay = 200) {
			return new Promise((resolve, reject) => {
				let attempts = 0;
				
				const checkTimeline = () => {
					attempts++;
					
					// Verificar si el timeline está listo
					if (this.isTimelineReady()) {
						resolve(true);
						return;
					}
					
					if (attempts >= maxAttempts) {
						// En lugar de fallar, intentar una última vez después de un delay más largo
						setTimeout(() => {
							if (this.isTimelineReady()) {
								resolve(true);
							} else {
								reject(new Error("Timeline component not ready after maximum attempts"));
							}
						}, 1000);
						return;
					}
					
					setTimeout(checkTimeline, delay);
				};
				
				checkTimeline();
			});
		},

		syncTimelineWithDates(startDate, endDate) {
			if (!this.isTimelineReady()) {
				return;
			}
			
			// Optimización: Evitar sincronizaciones redundantes
			if (this.isManualTimelineMoveInProgress) {
				return;
			}
			
			// Activar flag para bloquear range_change durante el movimiento manual
			this.isManualTimelineMoveInProgress = true;
			
			try {
				const timeline = this.$refs.timeline;
				const startISO = startDate.toISOString();
				const endISO = endDate.toISOString();
				
				// Optimización: Verificar si realmente necesita cambiar
				const currentWindow = timeline.getWindow();
				if (currentWindow && currentWindow.start && currentWindow.end) {
					const currentStart = new Date(currentWindow.start).getTime();
					const currentEnd = new Date(currentWindow.end).getTime();
					const newStart = startDate.getTime();
					const newEnd = endDate.getTime();
					
					// Si la diferencia es menor a 1 segundo, no actualizar
					const diffStart = Math.abs(currentStart - newStart);
					const diffEnd = Math.abs(currentEnd - newEnd);
					if (diffStart < 1000 && diffEnd < 1000) {
						this.isManualTimelineMoveInProgress = false;
						return;
					}
				}
				
				// Obtener la ventana actual ANTES del cambio
				const currentWindowBefore = timeline.getWindow();
				
				
				// Calcular la duración para determinar el zoom óptimo
				const durationMs = endDate - startDate;
				const durationHours = durationMs / (1000 * 60 * 60);
				
				
				
				// Mover la ventana del timeline una sola vez
				timeline.setWindow(startISO, endISO, {
					animation: {
						duration: 1000,
						easingFunction: "easeInOutQuad"
					}
				});
				
				// Optimización: Usar un solo timeout y RAF para mejor rendimiento
				requestAnimationFrame(() => {
					setTimeout(() => {
						// Verificar que la ventana se haya movido correctamente
						const currentWindow = timeline.getWindow();
						
						// Solo aplicar zoom si la ventana se movió correctamente
						if (currentWindow && currentWindow.start && currentWindow.end) {
							//this.applyOptimalZoom(durationHours);
						}
						
						// Desactivar el flag después de completar
						this.isManualTimelineMoveInProgress = false;
					}, 1500);
				});
				
			} catch (error) {
				
				// Desactivar el flag en caso de error
				this.isManualTimelineMoveInProgress = false;
			}
		},

		getCurrentTimelineDates() {
			if (this.isTimelineReady() && this.$refs.timeline) {
				try {
					const timeline = this.$refs.timeline;
					const currentWindow = timeline.getWindow();
					
					if (currentWindow && currentWindow.start && currentWindow.end) {
						return {
							start: new Date(currentWindow.start),
							end: new Date(currentWindow.end)
						};
					}
				} catch (error) {
					console.warn('Error getting current timeline dates:', error);
				}
			}
			
			return {
				start: this.timelineStart,
				end: this.timelineEnd
			};
		},

		validateSearchDates(searchParams) {
			if (!searchParams || !searchParams.start || !searchParams.end) {
				const currentDates = this.getCurrentTimelineDates();
				return {
					startDate: currentDates.start,
					endDate: currentDates.end,
					isValid: true,
					message: 'Using current timeline dates'
				};
			}
			
			try {
				const startDate = this.parseCustomDateFormat(searchParams.start);
				const endDate = this.parseCustomDateFormat(searchParams.end);
				
				if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
					const currentDates = this.getCurrentTimelineDates();
					return {
						startDate: currentDates.start,
						endDate: currentDates.end,
						isValid: false,
						message: 'Invalid dates provided, using current timeline dates'
					};
				}
				
				if (startDate >= endDate) {
					const currentDates = this.getCurrentTimelineDates();
					return {
						startDate: currentDates.start,
						endDate: currentDates.end,
						isValid: false,
						message: 'Start date must be before end date, using current timeline dates'
					};
				}
				
				return {
					startDate: startDate,
					endDate: endDate,
					isValid: true,
					message: 'Search dates are valid'
				};
			} catch (error) {
				const currentDates = this.getCurrentTimelineDates();
				return {
					startDate: currentDates.start,
					endDate: currentDates.end,
					isValid: false,
					message: 'Error validating dates, using current timeline dates'
				};
			}
		},

		handleRangeChange(properties) {
			if (this.isManualSearchInProgress) {
				return;
			}
			
			if (this.isManualTimelineMoveInProgress) {
				return;
			}
			
			// Optimización: Throttling para evitar demasiadas llamadas durante scroll
			const now = Date.now();
			const timeSinceLastChange = now - this.lastRangeChangeTime;
			
			if (timeSinceLastChange < this.rangeChangeThrottleMs) {
				// Cancelar debounce anterior y crear uno nuevo
				if (this.rangeChangeDebounce) {
					clearTimeout(this.rangeChangeDebounce);
				}
				
				this.rangeChangeDebounce = setTimeout(() => {
					this.executeRangeChange();
				}, this.rangeChangeThrottleMs);
				return;
			}
			
			// Si pasó suficiente tiempo, ejecutar inmediatamente
			this.lastRangeChangeTime = now;
			this.executeRangeChange();
		},
		
		executeRangeChange() {
			if (this.isTimelineReady() && this.$refs.timeline) {
				try {
					const timeline = this.$refs.timeline;
					const currentWindow = timeline.getWindow();
					
					if (currentWindow && currentWindow.start && currentWindow.end) {
						const timelineStartDate = new Date(currentWindow.start);
						const timelineEndDate = new Date(currentWindow.end);
						
						this.getAnalytics({
							start: this.formatDateForBackend(timelineStartDate),
							end: this.formatDateForBackend(timelineEndDate),
							deviceId: this.search?.deviceId || null,
							requestReason: 'range_change',
							isAutomaticRequest: true,
							timelineStartDate: timelineStartDate,
							timelineEndDate: timelineEndDate
						});
					}
				} catch (error) {
					console.warn('Error handling range change:', error);
				}
			}
		},
		getTimelineScale() {
			if (!this.isTimelineReady()) {
				return null;
			}

			try {
				const timeline = this.$refs.timeline;
				
				if (typeof timeline.getWindow !== 'function') {
					return null;
				}
				
				const window = timeline.getWindow();
				if (!window || !window.start || !window.end) {
					return null;
				}
				
				const timelineElement = timeline.$el || timeline.$refs?.timeline?.$el;
				let canvasWidth = 400;
				let canvasHeight = 400;
				
				if (timelineElement) {
					const container = timelineElement.querySelector('.vis-timeline') || timelineElement;
					if (container) {
						// Optimización: Usar getBoundingClientRect una sola vez en lugar de múltiples propiedades
						const rect = container.getBoundingClientRect();
						canvasWidth = rect.width || 400;
						canvasHeight = rect.height || 400;
					}
				}
				
				const timeRange = window.end - window.start;
				if (timeRange <= 0) {
					return null;
				}
				
				const pixelsPerMs = canvasWidth / timeRange;
				const pixelsPerSecond = pixelsPerMs * 1000;
				
				return {
					window: {
						start: window.start,
						end: window.end,
						duration: timeRange
					},
					canvas: {
						width: canvasWidth,
						height: canvasHeight
					},
					scale: {
						pixelsPerSecond: pixelsPerSecond
					}
				};
			} catch (error) {
				return null;
			}
		},


		clearVideoSearchDebouncing() {
			if (this.videoSearchDebounce) {
				clearTimeout(this.videoSearchDebounce);
				this.videoSearchDebounce = null;
			}
			
			if (this.currentVideoSearch) {
				this.currentVideoSearch = null;
			}
		},

		beforeDestroy() {
			// Optimización: Limpiar todos los timers y RAF
			if (this.automaticRequestDebounce) {
				clearTimeout(this.automaticRequestDebounce);
				this.automaticRequestDebounce = null;
			}
			
			if (this.analyticsRequestDebounce) {
				clearTimeout(this.analyticsRequestDebounce);
				this.analyticsRequestDebounce = null;
			}
			
			if (this.scrollTimeout) {
				clearTimeout(this.scrollTimeout);
				this.scrollTimeout = null;
			}
			
			if (this.rangeChangeDebounce) {
				clearTimeout(this.rangeChangeDebounce);
				this.rangeChangeDebounce = null;
			}
			
			if (this.rafId !== null) {
				cancelAnimationFrame(this.rafId);
				this.rafId = null;
				this.rafPending = false;
			}
			
			if (this.syncDateControlsDebounce) {
				clearTimeout(this.syncDateControlsDebounce);
				this.syncDateControlsDebounce = null;
			}
			
			this.clearVideoSearchDebouncing();
			this.group_promise.cancel = true;
			this.clearListeners();
			
			// Limpiar items y referencias para liberar memoria
			if (this.items && this.items.length > 0) {
				this.items.forEach(item => {
					if (item.metadata) {
						item.metadata.event = null;
						item.metadata.smartEvent = null;
						item.metadata.alert = null;
					}
				});
				this.items = [];
			}
		},

		setupBidirectionalSync() {
			setTimeout(() => {
				if (this.isTimelineReady()) {
					this.setupTimelineEventListeners();
					this.setupManualRangeChangeListener();
					this.setupRobustRangeChangeListener();
					this.setupRecordingEventListeners();
					// Hover deshabilitado para evitar problemas de memoria
					// this.setupTimelineHoverListeners();
				}
			}, 1000);
		},

		setupTimelineEventListeners() {
			if (!this.isTimelineReady()) {
				return;
			}

			try {
				const timeline = this.$refs.timeline;
				
				// Optimización: Throttling para evitar demasiadas llamadas durante scroll/zoom
				timeline.on('rangechanged', (properties) => {
					this.throttledSyncDateControls();
				});

				timeline.on('mousewheel', (properties) => {
					this.throttledSyncDateControls();
				});

				timeline.on('move', (properties) => {
					this.throttledSyncDateControls();
				});
			} catch (error) {
				// Error setting up timeline event listeners
			}
		},
		
		throttledSyncDateControls() {
			const now = Date.now();
			const timeSinceLastSync = now - this.lastSyncTime;
			
			if (timeSinceLastSync < this.syncThrottleMs) {
				// Cancelar debounce anterior y crear uno nuevo
				if (this.syncDateControlsDebounce) {
					clearTimeout(this.syncDateControlsDebounce);
				}
				
				this.syncDateControlsDebounce = setTimeout(() => {
					this.syncParentDateControls();
					this.lastSyncTime = Date.now();
				}, this.syncThrottleMs);
				return;
			}
			
			// Si pasó suficiente tiempo, ejecutar inmediatamente
			this.lastSyncTime = now;
			this.syncParentDateControls();
		},

		syncParentDateControls() {
			if (!this.isTimelineReady()) {
				return;
			}

			try {
				const timeline = this.$refs.timeline;
				const currentWindow = timeline.getWindow();
				
				if (!currentWindow || !currentWindow.start || !currentWindow.end) {
					return;
				}
				
				// Optimización: Usar RAF para emitir eventos de forma eficiente
				requestAnimationFrame(() => {
					this.$emit('timeline_range_changed', {
						startDate: this.formatDateForParent(new Date(currentWindow.start)),
						endDate: this.formatDateForParent(new Date(currentWindow.end)),
						startTime: this.formatTimeForParent(new Date(currentWindow.start)),
						endTime: this.formatTimeForParent(new Date(currentWindow.end))
					});
				});
			} catch (error) {
				// Error syncing parent date controls
			}
		},

		// Método para formatear fecha para el componente padre (formato YYYY/MM/DD)
		formatDateForParent(date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}/${month}/${day}`;
		},

		// Método para formatear hora para el componente padre (formato HH:MM)
		formatTimeForParent(date) {
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			return `${hours}:${minutes}`;
		},

		// Método para obtener el rango actual del timeline
		getTimelineCurrentRange() {
			if (!this.isTimelineReady()) {
				return null;
			}

			try {
				const timeline = this.$refs.timeline;
				const currentWindow = timeline.getWindow();
				
				if (!currentWindow || !currentWindow.start || !currentWindow.end) {
					return null;
				}

				const startDate = new Date(currentWindow.start);
				const endDate = new Date(currentWindow.end);
				const durationMs = endDate - startDate;
				const durationHours = durationMs / (1000 * 60 * 60);
				const durationDays = durationHours / 24;

				return {
					start: startDate,
					end: endDate,
					startFormatted: this.formatDateForParent(startDate),
					endFormatted: this.formatDateForParent(endDate),
					startTime: this.formatTimeForParent(startDate),
					endTime: this.formatTimeForParent(endDate),
					duration: durationMs,
					hours: durationHours,
					days: durationDays,
					startISO: startDate.toISOString(),
					endISO: endDate.toISOString()
				};

			} catch (error) {
				return null;
			}
		},

		// Método para sincronizar automáticamente cuando cambie el rango del timeline
		





		// Método para configurar un listener manual más directo
		setupManualRangeChangeListener() {
			if (!this.isTimelineReady()) {
				return;
			}

			try {
				const timeline = this.$refs.timeline;
				
				// Optimización: Ya está manejado en setupTimelineEventListeners con throttling
				// No duplicar listeners aquí
			} catch (error) {
				// Error setting up manual range change listener
			}
		},
		setupRobustRangeChangeListener() {
			if (!this.isTimelineReady()) {
				return;
			}

			try {
				const timeline = this.$refs.timeline;
				
				// Optimización: Ya está manejado en setupTimelineEventListeners con throttling
				// Solo agregar listener de resize si es necesario
				if (timeline.$el) {
					// Optimización: Throttling para resize también
					timeline.$el.addEventListener('resize', () => {
						this.throttledSyncDateControls();
					});
				}
			} catch (error) {
				// Error setting up robust range change listener
			}
		},

		// Método para configurar eventos de clic en grabaciones
		setupRecordingEventListeners() {
			if (!this.isTimelineReady()) {
				return;
			}

			try {
				const timeline = this.$refs.timeline;
				
				// Listener para clics en items del timeline
				timeline.on('click', (properties) => {
					if (properties.what === 'item') {
						const clickedItem = this.items.find(item => item.id === properties.item);
						console.log('OPEN  NEW  MODAL ', clickedItem);
						console.log('Looking for item ID:', properties.item);
						console.log('Available items count:', this.items.length);
						if (!clickedItem) {
							console.log('Item not found. First 5 item IDs:', this.items.slice(0, 5).map(i => i.id));
						}

						// Verificar si es un evento LPR (alerta)
						if (clickedItem && clickedItem.metadata && clickedItem.metadata.isLPR) {
							this.handleLPRClick(clickedItem);
						}
						// Verificar si es una alerta
						else if (clickedItem && clickedItem.metadata && clickedItem.metadata.isAlert) {
							this.handleAlertClick(clickedItem);
						}
						// Verificar si es un smart event
						else if (clickedItem && clickedItem.metadata && clickedItem.metadata.isSmartEvent) {
							this.handleSmartEventClick(clickedItem);
						}
						// Verificar si es una grabación
						else if (clickedItem && clickedItem.metadata && clickedItem.metadata.isRecording) {
							this.handleRecordingClick(clickedItem);
						}
						// Verificar si es un objeto
						else if (clickedItem && clickedItem.metadata && clickedItem.metadata.isObject) {
							this.handleObjectClick(clickedItem);
						}
						// Verificar si es un axle
						else if (clickedItem && clickedItem.metadata && clickedItem.metadata.isAxle) {
							this.handleAxleClick(clickedItem);
						}
						// Verificar si es un counter
						else if (clickedItem && clickedItem.metadata && clickedItem.metadata.isCounter) {
							this.handleCounterClick(clickedItem);
						}
					}
				});

				// Listener para doble clic en items del timeline
				/* timeline.on('doubleClick', (properties) => {
					if (properties.what === 'item') {
						const clickedItem = this.items.find(item => item.id === properties.item);
						if (clickedItem && clickedItem.metadata && clickedItem.metadata.isRecording) {
							this.handleRecordingClick(clickedItem);
						}
					}
				}); */

			} catch (error) {
				console.warn('Error setting up recording event listeners:', error);
			}
		},

	setupTimelineHoverListeners() {
		// Hover deshabilitado para evitar problemas de memoria
		return;
		
		/* Código deshabilitado
		if (!this.isTimelineReady()) {
			return;
		}

		try {
			const timeline = this.$refs.timeline;
			
			// Throttle para evitar demasiadas actualizaciones
			let hoverTimeout = null;
			const HOVER_THROTTLE_MS = 50;
			
			timeline.on('itemover', (properties) => {
				const itemId = properties.item;
				
				if (itemId) {
					// Limpiar timeout anterior si existe
					if (hoverTimeout) {
						clearTimeout(hoverTimeout);
						hoverTimeout = null;
					}
					
					hoverTimeout = setTimeout(() => {
						const hoveredItem = this.items.find(item => item.id == itemId);
						
						if (hoveredItem) {
							// Crear objeto ligero con solo los datos necesarios para evitar memory leaks
							const lightweightHoverInfo = {
								itemId: hoveredItem.id,
								content: hoveredItem.content || '',
								start: hoveredItem.start ? new Date(hoveredItem.start).getTime() : null,
								end: hoveredItem.end ? new Date(hoveredItem.end).getTime() : null,
								className: hoveredItem.className || '',
								// Solo incluir metadata esencial, no el objeto completo
								metadata: hoveredItem.metadata ? {
									eventCount: hoveredItem.metadata.eventCount || null,
									cantidadEventos: hoveredItem.metadata.cantidadEventos || null,
									isBucket: hoveredItem.metadata.isBucket || false,
									subgroup: hoveredItem.metadata.subgroup || null,
									alertType: hoveredItem.metadata.alertType || null,
									objectType: hoveredItem.metadata.objectType || null,
									category: hoveredItem.metadata.category || null,
									eventType: hoveredItem.metadata.eventType || null
								} : null,
								groupContent: this.groups.find(g => g.id === hoveredItem.group)?.content || '',
								groupId: hoveredItem.group
							};
							
							this.$emit('timeline_item_hover', lightweightHoverInfo);
						}
					}, HOVER_THROTTLE_MS);
				}
			});

			timeline.on('itemout', (properties) => {
				// Limpiar timeout pendiente
				if (hoverTimeout) {
					clearTimeout(hoverTimeout);
					hoverTimeout = null;
				}
				
				// Limpiar inmediatamente para liberar memoria
				this.$emit('timeline_item_hover', null);
			});
		} catch (error) {
			console.error("❌ [TimelinePlayback] Error setting up hover listeners:", error);
		}
		*/
	},


		handleLPRClick(lprItem) {
			if (!lprItem || !lprItem.metadata) {
				return;
			}

			console.log('LPR Item clicked:', lprItem);

			this.$emit('lpr_event_clicked', {
				eventData: lprItem,
				metadata: lprItem.metadata,
				plateNumber: lprItem.metadata.plateNumber,
				eventId: lprItem.id,
				timestamp: lprItem.metadata.unixTimestamp || lprItem.start,
				deviceId: lprItem.metadata.deviceId,
				evidence: lprItem.metadata.evidence
			});

			this.currentSegment = lprItem;
			this.itemSelected = lprItem;
		},

		handleAlertClick(alertItem) {
			if (!alertItem || !alertItem.metadata) {
				return;
			}

			console.log('Alert Item clicked:', alertItem);

			this.$emit('alert_event_clicked', {
				eventData: alertItem,
				metadata: alertItem.metadata,
				eventId: alertItem.id,
				timestamp: alertItem.metadata.unixTimestamp || alertItem.start,
				deviceId: alertItem.metadata.deviceId,
				evidence: alertItem.metadata.evidence,
				alertType: alertItem.metadata.alertType,
				alertId: alertItem.metadata.alertId
			});

			this.currentSegment = alertItem;
			this.itemSelected = alertItem;
		},

		handleSmartEventClick(smartEventItem) {
			if (!smartEventItem || !smartEventItem.metadata) {
				return;
			}

			console.log('Smart Event Item clicked:', smartEventItem);

			this.$emit('smart_event_clicked', {
				eventData: smartEventItem,
				metadata: smartEventItem.metadata,
				eventId: smartEventItem.id,
				timestamp: smartEventItem.metadata.unixTimestamp || smartEventItem.start,
				deviceId: smartEventItem.metadata.deviceId,
				evidence: smartEventItem.metadata.evidence,
				category: smartEventItem.metadata.category,
				eventType: smartEventItem.metadata.eventType,
				// Campos necesarios para buscar eventos del bucket
				startTimestamp: smartEventItem.metadata.startTimestamp || (smartEventItem.start ? (typeof smartEventItem.start === 'object' ? smartEventItem.start.getTime() : smartEventItem.start) : null),
				endTimestamp: smartEventItem.metadata.endTimestamp || (smartEventItem.end ? (typeof smartEventItem.end === 'object' ? smartEventItem.end.getTime() : smartEventItem.end) : null)
			});

			this.currentSegment = smartEventItem;
			this.itemSelected = smartEventItem;
		},

		handleRecordingClick(recordingItem) {
			if (!recordingItem || !recordingItem.metadata) {
				return;
			}

			const recording = recordingItem.metadata;
			
			this.$emit('recording_selected', {
				recordingId: recording.recordingId,
				filePath: recording.evidence || recording.urlpath,
				timestamp: recording.recordingStart.getTime(),
				duration: recording.recordingDuration,
				fileSize: recording.fileSize,
				recordingItem: recordingItem
			});

			const videoPath = recording.evidence || recording.urlpath;
			if (videoPath) {
				this.$emit("receive_src_img", this.$URL + videoPath);
				
				if (videoPath.indexOf('mp4') > 0) {
					this.$emit("receive_url_video", this.$URL + videoPath);
					if (this.refVideoPlayToComponent) {
						this.refVideoPlayToComponent.load();
					}
				}
			}

			this.currentSegment = recordingItem;
			this.itemSelected = recordingItem;
		},

		handleObjectClick(objectItem) {
			if (!objectItem || !objectItem.metadata) {
				return;
			}

			console.log('Object Item clicked:', objectItem);

			this.$emit('object_event_clicked', {
				eventData: objectItem,
				metadata: objectItem.metadata,
				eventId: objectItem.id,
				objectType: objectItem.metadata.objectType,
				objectId: objectItem.metadata.objectId,
				timestamp: objectItem.metadata.unixTimestamp || objectItem.start,
				deviceId: objectItem.metadata.deviceId,
				evidence: objectItem.metadata.evidence,
				confidence: objectItem.metadata.confidence,
				bbox: objectItem.metadata.bbox,
				subgroup: objectItem.metadata.subgroup,
				objectStart: objectItem.metadata.objectStart,
				objectEnd: objectItem.metadata.objectEnd,
				objectDuration: objectItem.metadata.objectDuration,
				// Campos necesarios para buscar eventos del bucket
				startTimestamp: objectItem.metadata.startTimestamp || (objectItem.start ? (typeof objectItem.start === 'object' ? objectItem.start.getTime() : objectItem.start) : null),
				endTimestamp: objectItem.metadata.endTimestamp || (objectItem.end ? (typeof objectItem.end === 'object' ? objectItem.end.getTime() : objectItem.end) : null)
			});

			this.currentSegment = objectItem;
			this.itemSelected = objectItem;
		},

		handleAxleClick(axleItem) {
			if (!axleItem || !axleItem.metadata) {
				return;
			}

			console.log('Axle Item clicked:', axleItem);

			this.$emit('axle_event_clicked', {
				eventData: axleItem,
				metadata: axleItem.metadata,
				eventId: axleItem.id,
				timestamp: axleItem.metadata.unixTimestamp || axleItem.start,
				deviceId: axleItem.metadata.deviceId,
				evidence: axleItem.metadata.evidence,
				title: axleItem.metadata.title,
				type: axleItem.metadata.type,
				// Campos necesarios para buscar eventos del bucket
				startTimestamp: axleItem.metadata.startTimestamp || (axleItem.start ? (typeof axleItem.start === 'object' ? axleItem.start.getTime() : axleItem.start) : null),
				endTimestamp: axleItem.metadata.endTimestamp || (axleItem.end ? (typeof axleItem.end === 'object' ? axleItem.end.getTime() : axleItem.end) : null)
			});

			this.currentSegment = axleItem;
			this.itemSelected = axleItem;
		},

		handleCounterClick(counterItem) {
			if (!counterItem || !counterItem.metadata) {
				return;
			}

			console.log('Counter Item clicked:', counterItem);

			this.$emit('counter_event_clicked', {
				eventData: counterItem,
				metadata: counterItem.metadata,
				eventId: counterItem.id,
				timestamp: counterItem.metadata.unixTimestamp || counterItem.start,
				deviceId: counterItem.metadata.deviceId,
				evidence: counterItem.metadata.evidence,
				title: counterItem.metadata.title,
				type: counterItem.metadata.type,
				// Campos necesarios para buscar eventos del bucket
				startTimestamp: counterItem.metadata.startTimestamp || (counterItem.start ? (typeof counterItem.start === 'object' ? counterItem.start.getTime() : counterItem.start) : null),
				endTimestamp: counterItem.metadata.endTimestamp || (counterItem.end ? (typeof counterItem.end === 'object' ? counterItem.end.getTime() : counterItem.end) : null)
			});

			this.currentSegment = counterItem;
			this.itemSelected = counterItem;
		},


	}
};
